import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import { rootReducers } from './redux/reducers'

const middleware = applyMiddleware(thunk)

export const store = createStore(rootReducers, middleware)

